import { useSearchParams } from "react-router-dom";

export const useSearchParam = (param: string): string => {
  const [searchParams] = useSearchParams();

  return searchParams.get(param) || "";
};
